(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 99540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(97560);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70326);
/* harmony import */ var _sy_app_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90583);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61867);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);




var Home = function(param) {
    var nonce = param.nonce, featureFlags = param.featureFlags;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            featureFlags["fullstory-tag-implementation"] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullStorySnippet, {
                    nonce: nonce
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sy_app_client__WEBPACK_IMPORTED_MODULE_2__/* .HomePage */ .Uv, {
                i18n: next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .i18n */ .ag
            })
        ]
    });
};
var FullStorySnippet = function(param) {
    var nonce = param.nonce;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        id: "fullstory",
        nonce: nonce,
        type: "text/javascript",
        dangerouslySetInnerHTML: {
            __html: "window['_fs_host'] = 'fullstory.com';\n				window['_fs_script'] = 'edge.fullstory.com/s/fs.js';\n				window['_fs_org'] = 'o-1DBHSZ-na1';\n				window['_fs_namespace'] = 'FS';\n				(function(m,n,e,t,l,o,g,y){\n					if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n					g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n					o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n					y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);\n					g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n					g.anonymize=function(){g.identify(!!0)};\n					g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n					g.log = function(a,b){g(\"log\",[a,b])};\n					g.consent=function(a){g(\"consent\",!arguments.length||a)};\n					g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n					g.clearUserCookie=function(){};\n					g.setVars=function(n, p){g('setVars',[n,p]);};\n					g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n					if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n					g._v=\"1.3.0\";\n				})(window,document,window['_fs_namespace'],'script','user');"
        }
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [835,583,774,888,179], function() { return __webpack_exec__(99540); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);